import { cn } from '@/lib/utils';
import ActionHeader from '@/components/molecules/actionHeader';
import Text from '@/components/atoms/text';

export default function SimpleHeaderLayout({ btnText, handleCloseBtn, handleBackBtn, children, showFormPriceFooter = false, showLegalFooter = false }) {
	const currentYear = new Date().getFullYear();

	return (
		<div className="flex flex-col min-h-screen bg-white">
			<ActionHeader variant="blue" btnText={btnText} handleCloseBtn={handleCloseBtn} handleBackBtn={handleBackBtn} />

			{children}

			{showLegalFooter && (
				<div className={cn('bg-eis-black', showFormPriceFooter && 'mb-40')}>
					<div className="flex flex-col w-full px-6 py-12 mx-auto md:px-10 lg:px-14 xl:px-eis-72 max-w-eis-1440">
						<Text type="small" variant="normal" className="text-white">
							Event Insurance Services is a limited company registered in England and Wales.
						</Text>
						<Text type="small" variant="normal" className="text-white">
							Registered number: 3238686 Event Insurance Services Limited are authorised and regulated by the Financial Conduct Authority, Ref No. 309998
						</Text>
						<Text type="small" variant="normal" className="mt-4 text-xs text-white">
							&copy; Copyright {currentYear} - Event Insurance Services. All rights reserved. Privacy and cookies
						</Text>
					</div>
				</div>
			)}
		</div>
	);
}
